import React from "react";
import { ContactUs } from "../components/emai";
import { ContactInfo, ContactWrapper, Info } from "../styles/contact";
import PhoneIcon from "@mui/icons-material/Phone";
import TelegramIcon from "@mui/icons-material/Telegram";
import EmailIcon from "@mui/icons-material/Email";
import { Background, NameCon } from "../styles/home";
import { BackgroundAnimation } from "components/backgroundAnimation";

const Contact = () => {
  return (
    <ContactWrapper>
      <BackgroundAnimation />
      <NameCon>
        <p>Let’s talk for your project done</p>
      </NameCon>
      <ContactInfo>
        <Info>
          <h1>Get in touch with me!</h1>{" "}
          <h4>
            <PhoneIcon /> Contact Number: <span>+821082547679</span>
          </h4>
          <h4>
            {" "}
            <TelegramIcon /> Telegram:{" "}
            <a style={{ color: "red" }} href="https://t.me/unbemon">
              https://t.me/unbemon
            </a>
          </h4>
          <h4>
            {" "}
            <EmailIcon /> Email me:
            <a
              href="mailto:inomjonov.dev@gmail.com"
              style={{ marginLeft: 6, color: "red" }}
            >
              inomjonov.dev@gmail.com
            </a>
          </h4>
        </Info>
        <ContactUs />
      </ContactInfo>
    </ContactWrapper>
  );
};

export default Contact;
